export enum RecurringType {
    SINGLE = 'SINGLE',
    MONFRI = 'MONFRI',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY',
    EVERYDAY = 'EVERYDAY',
    SAMEDAY = 'SAMEDAY',
}
